// export const SIDEBAR_COLORS = {
//   primary: "#1a2836",
//   primaryLight: "#203142",
//   primaryDark: "#0b294d",
//   gradientBg: "linear-gradient(180deg, #0b294d 0%, #0a3260 100%)",
//   hoverBg: "rgba(255, 255, 255, 0.1)",
//   activeBg: "#1C60F6",
//   activeHoverBg: "#1650D8",
//   border: "rgba(255, 255, 255, 0.08)",
//   scrollbarThumb: "rgba(255, 255, 255, 0.2)",
//   textDefault: "rgba(255, 255, 255, 0.65)",
//   iconDefault: "#ffffff",
//   borderNeutral: "rgba(255, 255, 255, 0.15)",
// };
//  primary: "#103f6b",


export const SIDEBAR_COLORS = {
  primary: "#313C4C",
  primaryLight: "#3A4658",
  primaryDark: "#252E3A",
  gradientBg: "#313C4C",

  hoverBg: "rgba(255, 255, 255, 0.06)",
  activeBg: "rgba(255, 255, 255, 0.14)",
  activeBorder: "#FFFFFF",
  activeHoverBg: "rgba(255, 255, 255, 0.18)",
  activeTint: "rgba(255, 255, 255, 0.07)",   // for expanded/parent items
  activeText: "#FFFFFF",

  border: "rgba(255, 255, 255, 0.08)",
  borderNeutral: "rgba(255, 255, 255, 0.12)",
  scrollbarThumb: "rgba(255, 255, 255, 0.2)",

  sectionLabel: "rgba(255, 255, 255, 0.38)",
  textDefault: "rgba(255, 255, 255, 0.72)",
  textHover: "#FFFFFF",

  iconDefault: "rgba(255, 255, 255, 0.78)",
  iconActive: "#FFFFFF",
};
export default SIDEBAR_COLORS;
